import http from 'plugins/axios';

export default {
  createLCtf(data) {
    return http.post({
      url: '/la/admin/config/set/create',
      data,
      dataType: 'form'
    });
  },
  getAllCoin() {
    return http.get({
      url: '/la/admin/coin/list'
    });
  },
  getList(data) {
    return http.get({
      url: '/la/admin/config/set/list',
      data
    });
  },
  delOne(type){
    return http.post({
      url:`/la/admin/config/set/del?type=${type}`,
      
    })
  }
};
